export default __webpack_public_path__ + "static/media/website-logo.2f480e62.svg";